import React, {memo} from 'react'
import {withHelmet, withMeData} from '../../hoc'
import {RedocUI} from '../service/versions/docs'
import {TopNav} from '../shared'
import {Container} from 'semantic-ui-react'

let ApiDocs = (props) => {
  return (
    <Container style={{marginTop: '5em', marginBottom: '2em'}} fluid>
      <TopNav {...props}/>
      <RedocUI
        contract='https://servicemocks.com/api/services/5d8a1e52c2b9e1503ee8e9dc/versions/5d8a1e52c2b9e1503ee8e9db/contract/raw'/>
    </Container>
  )
}

ApiDocs = withHelmet(ApiDocs, 'API Docs')
ApiDocs = withMeData(ApiDocs, 'Loading...', false)
ApiDocs = memo(ApiDocs)
export {ApiDocs}

export default ApiDocs